// 直线
import rlEntity from "./rlEntity";
import { create2dAnyLine } from "../threeObject/index";

import mxcad from "mxcad";
import { rlLineAxis } from "./rlLineAxis";
const { McDbPoint, McDbLine, McGePoint3d, McCmColor } = mxcad;

class rlLine extends rlEntity {
  constructor() {
    super();

    this.m_stJoint = null; // 起点节点
    this.m_edJoint = null; // 终点节点
    this.points = []; // 顶点列表

    this.McDbrlLine = new McDbLine(); //关联的cad直线类
    this.classTypeName = "rlLine";
    this.m_groupName = "rlLineGroup";
  }

  // 自定义对象在绘制时会重新创建
  create() {
    return new this.constructor();
  }

  // 设置点生成直线
  setPoints(points) {
    this.points = [
      new THREE.Vector3(...points[0]),
      new THREE.Vector3(...points[1]),
    ];
  }

  // 添加顶点
  addVertexAt(point) {
    this.points.push(point);
  }

  // 绘制
  drawLine(s, e) {
    this.points = [s, e];
  }

  // 绘制
  worldDraw(pWorldDraw) {
    // 创建任意线段three.js的线对象
    this.McDbrlLine.startPoint = new McGePoint3d(
      this.points[0]["x"],
      this.points[0]["y"],
      this.points[0]["z"]
    );
    this.McDbrlLine.endPoint = new McGePoint3d(
      this.points[1]["x"],
      this.points[1]["y"],
      this.points[1]["z"]
    );
    this.McDbrlLine.trueColor = new McCmColor(0, 0, 0);
    this.McDbrlLine.highlight(false);
    this.McDbrlLine.setxDataString("mcObjectId", this.objectId().toString());

    const wLineObj = create2dAnyLine(this.points);

    // 计算线对象的包围盒
    wLineObj.geometry.computeBoundingBox();
    // 创建一个三维点对象
    this.centerPt = new THREE.Vector3();
    // 获取中心点
    wLineObj.geometry.boundingBox.getCenter(this.centerPt);
    // 动态绘制这个线对象

    pWorldDraw.drawEntity(wLineObj);
  }

  // 删除
  erase() {
    this.McDbrlLine.erase();
    super.erase();
  }

  // 输出同理
  dwgOut(obj) {
    this.onDwgOut(obj);
    obj["points"] = [];
    obj["centerPt"] = this.centerPt;
    this.points.forEach((val) => {
      obj["points"].push(val.clone());
    });
    // if (this.ID) {
    //   this.statusType = 2
    // }
    return obj;
  }

  // 数据读入
  dwgIn(obj) {
    // // 这里是公共的属性
    this.onDwgIn(obj);
    //  // 这里是自定义对象自己的属性
    let ary = obj["points"];
    this.points = [];
    this.centerPt = obj["centerPt"];
    ary.forEach((val) => {
      this.points.push(val.clone());
    });
    return true;
  }

  // test
  // 画线的函数
  async draw() {
    return new Promise((resolve, reject) => {
      // 实例化取点对象
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();

      const anyLine = new rlLineAxis();

      // 鼠标第一次点击
      getPoint.go((status) => {
        if (status != 0) {
          return;
        }
        // 当前鼠标位置
        const pt1 = getPoint.value();

        // 实例化任意线段
        anyLine.points.push(pt1);
        getPoint.setUserDraw((currentPoint, pWorldDraw) => {
          if (anyLine.points.length === 0) return;
          if (anyLine.points.length >= 2) {
            // 重复执行绘制
            pWorldDraw.drawCustomEntity(anyLine);
          }
          // 设置点位刷新
          anyLine.drawLine(
            currentPoint,
            anyLine.points[anyLine.points.length - 1]
          );
          // anyLine.points.push(currentPoint.clone())
        });

        getPoint.go(() => {
          // 鼠标右键结束绘制
          rlAppObj.rlMxDrawObject.addMxEntity(anyLine);
          rlAppObj.mxcadObject.drawEntity(anyLine);
          resolve(anyLine);
        });
      });
    });
  }
}

export { rlLine };
